/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetLoyaltyStoresCorporationIdOffersNotFound
 */
export interface GetLoyaltyStoresCorporationIdOffersNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetLoyaltyStoresCorporationIdOffersNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetLoyaltyStoresCorporationIdOffersNotFound interface.
 */
export function instanceOfGetLoyaltyStoresCorporationIdOffersNotFound(value: object): value is GetLoyaltyStoresCorporationIdOffersNotFound {
    return true;
}

export function GetLoyaltyStoresCorporationIdOffersNotFoundFromJSON(json: any): GetLoyaltyStoresCorporationIdOffersNotFound {
    return GetLoyaltyStoresCorporationIdOffersNotFoundFromJSONTyped(json, false);
}

export function GetLoyaltyStoresCorporationIdOffersNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLoyaltyStoresCorporationIdOffersNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetLoyaltyStoresCorporationIdOffersNotFoundToJSON(json: any): GetLoyaltyStoresCorporationIdOffersNotFound {
    return GetLoyaltyStoresCorporationIdOffersNotFoundToJSONTyped(json, false);
}

export function GetLoyaltyStoresCorporationIdOffersNotFoundToJSONTyped(value?: GetLoyaltyStoresCorporationIdOffersNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

